<div class="modal-header position-relative p-0 overflow-hidden" style="border: none;">
  <img [src]="product.picture" class="w-100 rounded-top" alt="Product image" style="max-height: 200px; object-fit: cover;">
  <button type="button" class="btn-close position-absolute top-0 end-0 m-3" (click)="activeModal.close()"></button>
</div>
<div class="modal-body pb-0">
  <div class="card mb-3">
    <div class="card-body p-3 pb-0">
        <div class="input-group mt-0 mb-3 shadow">
          <span class="input-group-text" style="border: none !important; background-color: #eee !important;">
            <img alt="Sparkles" i18n-alt src="assets/images/sparkles.webp" style="width: 1.2rem; height: 1.2rem; position: relative; top: -2px;"></span>
          <div #promptInput enterkeyhint="send"
            (keydown.enter)="agentSend(); $event.preventDefault();"
            [attr.placeholder]="firstPromptSent ? '': placeholderText" contenteditable="true"
            class="textarea form-control" style="border: none !important; outline: none !important; box-shadow: none !important;">
          </div>
          <button *ngIf="!isMobile" (click)="agentSend()" class="btn btn-primary">
            <fa-icon [icon]="fa.faPaperPlane" style="color: #fff;" class="plane-sm-hack"></fa-icon>
          </button>
        </div>

        <div class="m-2">
          <div class="row">
            <div class="p-0" style="width: 3rem; height: 3.5rem;">
              <img alt="Nuuduu logo" i18n-alt src="assets/images/logo-round.webp"
                style="border-radius: 50%; width: 3rem;" class="pr-5 shadow mx-1">
            </div>
            <div class="col align-middle px-3">
              <div class="text-muted" i18n>Sales Agent</div>
              <div *ngIf="!firstPromptSent" class="d-inline-block">
                <p>
                  {{ prompt | translateField: 'greeting' }}
                  <span *ngIf="!prompt" [innerHTML]="animatedDots"></span>&nbsp;
                </p>
              </div>
              <div *ngIf="firstPromptSent && agentResponse == ''" class="d-inline-block">
                <p>
                  <span [innerHTML]="animatedDots"></span>&nbsp;
                </p>
              </div>
              <div *ngIf="firstPromptSent && agentResponse != ''" class="d-inline-block" [innerHTML]="agentResponse"></div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body pb-0">

      <div class="">
        <h4 class="mb-0">{{ product | translateField: 'name' }} (<span style="text-transform: lowercase;">{{
            product.unit | i18nSelect: productUnits }}</span>)</h4>
        <p class="mb-0">{{ product | translateField: 'description' }}</p>
        <p class="mb-0">{{ product | translateField: 'description_local' }}</p>
      </div>

      <div class="quantity-controls mt-3 mb-3">
        <div class="input-group">
          <button class="btn btn-primary" type="button" (click)="decrementNumber()">
            <fa-icon [icon]="fa.faMinus" style="color: #fff; position: relative; top: -1px;"></fa-icon>
          </button>
          <input type="text" inputmode="decimal" decimalInput class="form-control text-center" (blur)="updateNumber()" [(ngModel)]="number" min="1">
          <button class="btn btn-primary" type="button" (click)="incrementNumber()">
            <fa-icon [icon]="fa.faPlus" style="color: #fff; position: relative; top: -1px;"></fa-icon>
          </button>
        </div>
      </div>

      <div class="notes-field mb-3">
        <label for="notes" i18n>Notes to partner</label>
        <textarea rows="5" class="form-control" id="notes" [(ngModel)]="notes"
          placeholder="Add any special instructions..." i18n-placeholder></textarea>
      </div>

      <button *ngIf="!noNext && (!values || fromAi)" type="button" class="btn btn-primary w-100 mb-3"
        (click)="placeOrder({ next: true })" i18n>
        Add to order and go to next step
      </button>
      <button *ngIf="!values || fromAi" type="button" class="btn btn-secondary w-100 mb-3"
        (click)="placeOrder({ next: false })" i18n>
        Add to order and continue shopping
      </button>
      <button *ngIf="!noNext && values && !fromAi" type="button" class="btn btn-primary w-100 mb-3"
        (click)="placeOrder({ next: true })" i18n>
        Save changes and go to next step
      </button>
      <button *ngIf="values && !fromAi" type="button" class="btn btn-secondary w-100 mb-3"
        (click)="placeOrder({ next: false })" i18n>
        Save changes
      </button>
      <button *ngIf="values && !fromAi" type="button" class="btn btn-danger w-100 mb-3" (click)="removeOrder()" i18n>
        Remove from order
      </button>
    </div>
  </div>
</div>
<div class="modal-footer">
  
</div>